import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import IPost from '../../types/Post';  
import { IGenericResponse } from 'state/interfaces';
import { FeedQueryParams } from 'state/interfaces/Feed';

export const feedApi = createApi({
  reducerPath: 'feedApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_SERVER_ENDPOINT}`, credentials: "include" }),
  endpoints: (builder) => ({
    getFeed: builder.query<IPost[], FeedQueryParams | void>({
      query: (params) => ({
        url: '/post/feed',
        method: 'GET',
        params: params || {} 
      }),
      transformResponse: (response: IGenericResponse<IPost[]>) => [response.data[0]], 
    }),
  }),
});

export const { useGetFeedQuery } = feedApi;
